const SPECIAL_MENTIONS = ['card', 'board'];

/**
 * Check if the string matches one of the special mentions. The function will
 * automatically remove the '@' symbol (if present) from the mention argument.
 *
 * @param mention string
 * @returns boolean
 */

export const isSpecialMention = (mention: string) => {
  return SPECIAL_MENTIONS.includes(mention.replace('@', ''));
};
